<template>
    <div class="n-flex n-flex-a-c n-flex-dr-c n-flex-j-c n-h-1 n-p-2 c-max-width n-m-auto">
        <a-spin :spinning="loadings">
            <div class="n-col-1 c-shadow info n-flex n-flex-dr-c n-bg-1 n-radius-10 n-p-6">
                <div class="n-flex n-flex-a-c n-b-line n-col-1">
                    <div class="list-thumb n-flex-s">
                        <NImage class="list-thumb-image n-col-1 n-h-1"
                                type="cover"
                                v-if="data?.coverPicture"
                                :src="data?.coverPicture">
                        </NImage>
                    </div>

                    <div class="n-ml-4">
                        <h1 class="n-f-bold n-c-4 n-m-0 n-f-10">{{ data?.title }}</h1>

                        <h4 class="n-c-4 n-mb-0 n-mt-2 n-f-normal"
                            v-if="publication && publication.publishDate">
                            <label class="n-flex-s">{{ LAN.common.publishDate }}:&nbsp;&nbsp;</label>{{ publication ?
                                  parseCDate(publication.publishDate) : '-' }}
                        </h4>

                        <span class="n-block n-c-4 n-mt-2"
                              v-if="publication && publication.isbn13">
                            <span class="n-flex-s">ISBN: {{ publication.isbn13 }}</span>
                        </span>

                        <span class="n-block n-c-4 n-mt-2"
                              v-if="publication && publication.size">{{ LAN.book.size1 }}: {{ publication.size }}</span>

                        <span class="n-f-10 n-c-base n-block n-mt-2">{{publication.currency + ' ' + formatNumber(publication.listPrice, 2) }}</span>
                    </div>
                </div>

                <div class="n-mt-4 n-flex n-flex-a-c n-flex-w">
                    <h4 v-if="checking == 0"
                        class="n-f-10 n-c-red n-m-0 n-flex-g n-plr-2"><a-spin class="n-mr-4" /> {{ LAN.common.receivePaid }}</h4>

                    <h4 v-else-if="checking == 1"
                        class="n-f-10 n-c-green n-m-0 n-flex-g n-plr-2">{{ LAN.common.successPaid }}</h4>

                    <h4 v-else-if="checking == -1"
                        class="n-f-10 n-c-red n-m-0 n-flex-g n-plr-2">{{ LAN.common.errorPaid }}</h4>

                    <div class="n-flex n-flex-a-c n-m-0 n-flex-j-c n-flex-w">
                        <div class="n-p-2">
                            <a-button class="c-tab-link c-tab-link-event"
                                      @click="$router.replace({name: 'BDetail', query: {id: $route.query.bid}})">{{ LAN.common.backBook }}</a-button>
                        </div>
                        <div class="n-p-2">
                            <a-button type="primary"
                                      class="c-tab-link c-tab-link-event"
                                      @click="$router.replace({name: 'mine', query: {type: 'order'}})">{{ LAN.common.goOrder }}</a-button>
                        </div>
                    </div>
                </div>
            </div>
        </a-spin>
    </div>
</template>
<script >
    import { mapMutations, mapState } from 'vuex';
    import nui from '@/assets/script';
    import NImage from '@/components/nui/NImage/NImage.vue'

    export default {
        name: 'NoAuth',
        computed: {
            ...mapState(nui.extendVue.extendState.concat([])),
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                publication: {},
                data: {},
                loadings: false,
                checking: 0
            })
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat(['setMenuStatus'])),

            NMounted () {
                this.loadings = true

                this.request(this.API.bookDetail, {
                    params: { id: this.$route.query.bid }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.data = res.data;
                        this.publication = res.data.publication.filter(item => item.id == this.$route.query.pid)[0]
                    }
                    this.loadings = false
                }).catch(err => {
                    this.loadings = false
                })

                this.checking = 0;

                this.request(this.API.payStatus, {
                    params: { paymentIntentId: this.$route.query.payment_intent }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.checking = res.data ? 1 : -1
                    }
                }).catch(err => {
                    this.checking = -1
                })
            }
        }),
        components: {
            NImage
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss" scoped>
    .list-thumb {
        width: 170px;
        height: 246px;
    }

    .info {
        // width: 800px;
        // max-width: calc(100vw - 20px);
    }
</style>